export default "__VITE_ASSET__BuJoH6$s__"